import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetBlogByUsernameAndSlugQuery } from '../slices/blogsApiSlice';
import Loader from '../components/Loader';
import { config } from '../config/indexConfig';

const BlogPost = () => {
  const { username, slug } = useParams();
  const { data: post, isLoading, isError, error } = useGetBlogByUsernameAndSlugQuery({ username, slug });

  useEffect(() => {
    if (!post) return;
    const title = post.metaTitle || post.title;
    const description = post.metaDescription || (post.content ? String(post.content).slice(0, 160) : '');
    const image = post.ogImage || post.featuredImageUrl || '';
    const ogTitle = post.ogTitle || title;
    const ogDescription = post.ogDescription || description;

    document.title = title;

    const ensureMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}='${key}']`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    ensureMeta('name', 'description', description);
    if (Array.isArray(post.metaKeywords) && post.metaKeywords.length) {
      ensureMeta('name', 'keywords', post.metaKeywords.join(', '));
    }

    ensureMeta('property', 'og:title', ogTitle);
    ensureMeta('property', 'og:description', ogDescription);
    if (image) ensureMeta('property', 'og:image', image);

    // Twitter card basic
    ensureMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    ensureMeta('name', 'twitter:title', ogTitle);
    ensureMeta('name', 'twitter:description', ogDescription);
    if (image) ensureMeta('name', 'twitter:image', image);
  }, [post]);

  useEffect(() => {
    // Track blog read
    if (!post || !post.projectName) return;
    try {
      fetch(`${config.api.baseUrl}/analytics/track/blog/${encodeURIComponent(post.projectName)}`.replace(/\/+$/, ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ blogId: post.slug || post._id }),
      }).catch(() => {});
    } catch (_) {}
  }, [post]);

  if (isLoading) return <Loader />;
  if (isError) return <div className='container py-5'>Error: {error?.data?.message || 'Unable to load blog'}</div>;

  return (
    <div className='container py-5'>
      <h1 className='mb-3'>{post.title}</h1>
      {post.featuredImageUrl ? (
        <img src={post.featuredImageUrl} alt={post.title} style={{ maxWidth: '100%', height: 'auto', borderRadius: 8, marginBottom: 16 }} />
      ) : null}
      <div className='text-muted mb-4'>{new Date(post.publishedAt || post.createdAt).toLocaleString()}</div>
      <div style={{ whiteSpace: 'pre-wrap' }}>{post.content}</div>
    </div>
  );
};

export default BlogPost;


